import React from 'react';
import '../static/css/list.css';
import {category} from '../config/category';
import {NavLink, withRouter} from 'react-router-dom';
import axios from 'axios';
import AlibabaAds from "./Ads/AlibabaAds";
import {Helmet} from "react-helmet";

class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            category: '',
            category1: category,
            location: '',
            length: [1, 2, 3]
        };
    }

    componentDidMount() {
        this.getAds(this.props.match.params);
        this.setState({category: this.props.match.params.category})
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log('receive', nextProps, nextContext)
        this.setState({category: nextProps.match.params.category})
        this.getAds(nextProps.match.params);
    }

    getAds = ({category, city}) => {
        const existLocation = JSON.parse(localStorage.getItem('location'));
        this.setState({location: existLocation});

        if (category) {
            let url = `${process.env.REACT_APP_BACKEND_URL}/item/?category=` + category;
            url = existLocation ? url + `&city=${existLocation.city}` : url;
            axios.get(url)
                .then((res) => {
                    this.setState({data: res.data});
                }).catch(err => console.error(err))
        } else {
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/item/cities/?city=` + city)
                .then((res) => {
                    this.setState({data: res.data});
                }).catch(err => console.error(err))

        }
    }

    render() {
        const {category, category1, location} = this.state;
        console.log('cate', category);
        let cates = category1.map(a => {
            return a.cate;
        })
        return (
            <React.Fragment>
                <Helmet
                    titleTemplate="euBines.com | %s"
                >
                    <title>{`${category}`}</title>
                    <meta name="description"
                          content={`euBines.com: Buy and sell something. Use euBines.com to find the products and offers of today. Selling ${category} and more in ${location && location.city ? location.city : 'London'}, ${location && location.country ? location.country : 'United Kingdom'}`}/>
                    <meta name="keywords"
                          content={`euBines.com: Buy from your neighbours and sell something. Use euBines.com to find the products and offers of today. ${cates} and more.`}/>
                    <link rel="canonical" href={window.location}/>


                </Helmet>
                <div className="container">
                    <div id="categories" className="row">
                        {
                            this.state.category1.map((item) => {
                                return (
                                    <div className="col-md-3" key={item.cate}>
                                        <NavLink to={`/${item.cate}/listing`}>
                                            <div className="d-flex">
                                                <img src={item.ic} alt={item.cate} height="20"
                                                     width="20"/>
                                                <p id="cate-ad">
                                                    {item.cate}
                                                </p>
                                            </div>
                                        </NavLink>
                                    </div>

                                );
                            })
                        }
                        {/*{*/}
                        {/*    this.state.category.map((item, i) =>*/}
                        {/*        (*/}
                        {/*            <NavLink to={`/list/${item.cate}`} key={item.cate}>*/}
                        {/*                <div id="cate-item">*/}
                        {/*                    /!*<img src={item.ic} alt={item.cate} height="50" width="50"/>*!/*/}
                        {/*                    <p>{item.cate}</p>*/}
                        {/*                </div>*/}
                        {/*            </NavLink>*/}
                        {/*        )*/}
                        {/*    )*/}
                        {/*}*/}

                    </div>
                    <hr/>
                    {
                        this.state.data.length === 0 ? <NoAd/> : <ListItem data={this.state.data}/>
                    }
                    <hr/>
                    {category !== '' &&
                    <AlibabaAds category={category}/>
                    }
                </div>
            </React.Fragment>

        );
    }
}

const ListItem = (props) => (
    <div>
        {
            props.data.map((item) => {
                return (
                    <NavLink
                        to={`/${item.productId ? item.productId : item.category.toLowerCase() + '-' + (item.condition !== undefined ? item.condition.toLowerCase() : 'ads') + '-' + item.title.toLowerCase()}/item/${item._id}`}
                        key={item._id}>
                        {console.log(item._id)}
                        <div className="row">
                            <div id="list">
                                <div id="item-img">
                                    <img src={`${process.env.REACT_APP_BACKEND_URL}/uploads/` + item.photo[0]}
                                         alt="List-Item"
                                         height='120' id="img"/>
                                </div>
                                <div id="item-detail">
                                    <p id="product-name">{item.title}</p>
                                    <p id="product-cate">{item.category}</p>
                                    <p id="seller-location">{item.city}</p>
                                    <p id="product-price"><span>£</span>{item.price}</p>
                                </div>
                                <div id="item-icon">
                                    <i className="far fa-heart"/>
                                </div>


                            </div>
                        </div>
                    </NavLink>
                );

            })
        }
    </div>
)

const NoAd = () => (
    <div style={{margin: '50px auto', width: '80%', borderRadius: '20px', height: '300px'}}>
        {/*<img src={require('../assests/broken.png')} alt="Empty" height="150" width="150"*/}
        {/*     style={{margin: '10px auto', display: 'block'}}/>*/}
        <h3>Sorry 🙃, No ads found.</h3>
        <h4 style={{textAlign: 'center', color: 'gray'}}>Ads in this area for this category are now empty.
            Please see similar ads below.</h4>

    </div>
)


export default withRouter(List);



// WEBPACK FOOTER //
// ./src/components/List.js